
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import vuexStore from "@/store/vuex-store";
import _ from "lodash-es";
import UploadImage from "@/lib/common/uploadImage";
import Agent from "@/lib/common/agent";
import Video from "@/lib/common/video";
import request from "@/lib/request/request";
import Config from "@/config/config";
@Component({
  components: {}
})
export default class IdAi extends Vue {
  connectCode = "";

  mounted() {
    this.connectCode = (this.$route.query.c as string).replace(
      /[^a-zA-Z0-9]/g,
      ""
    );
  }

  start(type: any) {
    if (type == 1)
      this.$router.push(`/identity-face-exam?c=${this.connectCode}`);
    else this.$router.push(`/identity-card-exam?c=${this.connectCode}`);
  }
}
